import { decode as base64_decode, encode as base64_encode } from 'base-64';
export const encodeBase64 = (stringParam) => {
    const encoded = base64_encode(stringParam);
    return encoded;
};
export const decodeBase64 = (stringParam) => {
    const decoded = base64_decode(stringParam);
    return decoded;
};
